/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-03-08 14:25:49
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import { preventRepeatClick } from './directives/index'
import '../theme/index.css'
import 'font-awesome/css/font-awesome.css'
import 'babel-polyfill'
import md5 from 'js-md5'
import store from './store'
Vue.use(ElementUI)
Vue.use(preventRepeatClick)
Vue.config.productionTip = false
Vue.prototype.$md5 = md5
export const event = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store: store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js